import { COMBO_URL, ARVORE_ROOT_PATH } from 'config/vars'
import { ROOT_PATH } from 'routes/paths'
import Reader from 'utils/reader'
import { READER_PATH } from 'config/vars'
import Regex from 'utils/regex'
import { useEffect } from 'react'
import { setCookieOnDomain } from 'utils/cookies'
import { BASE_URL_CRIAR } from '../login/constants'
import { criarUrl } from 'components/modular/tabs-home/constants'
import Url, { getQueryVariable } from 'utils/url'

const READER_PATH_REGEX = new RegExp(
  `${Regex.escape(READER_PATH)}/(.+)\\?p=(.+)`
)

const isCriarPath =
  getQueryVariable('url') &&
  decodeURIComponent(getQueryVariable('url')) === BASE_URL_CRIAR

const LoginByJWT = props => {
  const token = global.jwt
  const redirectUrl = global.redirect_url
  // Token is now stored in cookie via setCookieOnDomain
  setCookieOnDomain('access_token', token, 30)

  useEffect(() => {
    if (props.match?.path?.includes?.('auth/sso')) {
      // webview
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView?.postMessage(
          JSON.stringify({
            msg: 'auth-sso',
            data: token
          })
        )
      }

      // popup
      const ALLOWED_ORIGINS = [COMBO_URL, ARVORE_ROOT_PATH]
      if (window.opener && window.opener !== window) {
        ALLOWED_ORIGINS.forEach(origin => {
          window.opener?.postMessage?.(
            {
              msg: 'auth-sso',
              token: token
            },
            origin
          )
        })
      }
    }

    if (isCriarPath) {
      return Url.set(criarUrl)
    }

    if (redirectUrl) {
      const matchReader = redirectUrl.match(READER_PATH_REGEX)
      if (matchReader) {
        const [, slug, apiToken] = matchReader
        Reader.open(slug, apiToken)
      } else {
        Url.set(redirectUrl)
      }
    } else {
      global.location = ROOT_PATH
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

export default LoginByJWT
